export default __webpack_public_path__ + "static/media/factory.a0773cd1.svg";